module.exports = __webpack_public_path__ + "img/hard-hat-no.12868d4b.svg";